import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Select from "@mui/material/Select";
import "./cheat_modal.css";
import useImgur from "hooks/useImgur";
import { useCheats } from "hooks/useCheats";
import createSlug from "global/function";
import AIRalert from "components/General/alert/alert";
import Divider from "@mui/material/Divider";

//Images
import default_mini from "assets/images/default_mini.png";
import { IMGUR_CLIENT_ID } from "apis/private/apis";

export default function Cheat_Modal({ open, setOpen, type }) {
  const {
    ok,
    error,
    createCheat,
    loading,
    editingCheat,
    setEditingCheat,
    updateCheat,
    getCategories,
    categories,
  } = useCheats(false);
  const { ImageUpload } = useImgur();
  const [file, setFile] = useState(null);
  const [file2, setFile2] = useState(null);
  const [imageUrl, setImageUrl] = useState("");
  const [imageDetails, setImageDetails] = useState("");
  const [category, setCategory] = useState("others");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [videoUrl, setVideoUrl] = useState("");
  const [download1, setDownload1] = useState("");
  const [download1_title, setDownload1_Title] = useState("");
  const [download2, setDownload2] = useState(null);
  const [imgur, setImgur] = useState({ error: false, msg: "" });
  const [download2_title, setDownload2_Title] = useState(null);

  useEffect(() => {
    if (type == "edit") {
      setImageUrl(editingCheat.imageUrl);
      setCategory(editingCheat.category);
      setName(editingCheat.name);
      setDescription(editingCheat.description);
      setVideoUrl(editingCheat.videoUrl);
      setDownload1(editingCheat.download1);
      setDownload2(editingCheat.download2);
      setDownload2_Title(editingCheat.download2_title);
      setDownload1_Title(editingCheat.download1_title);
    } else {
      setImageUrl("");
      setCategory("others");
      setName("");
      setDescription("");
      setVideoUrl("");
      setDownload1("");
      setDownload2("");
      setDownload2_Title("");
      setDownload1_Title("");
    }
    getCategories();
  }, [type, editingCheat]);

  const submitCheat = () => {
    let cheatMounted = {
      name: name,
      category: category,
      imageUrl: imageUrl,
      imageDetails: imageDetails,
      description: description,
      videoUrl: videoUrl,
      download1: download1,
      download2: download2,
      slug: createSlug(name),
      updateDate: new Date(),
      download1_title: download1_title,
      download2_title: download2_title,
      likes: 0,
    };
    if (type == "edit") {
      updateCheat({ ...cheatMounted, id: editingCheat.id });
    } else {
      createCheat(cheatMounted);
    }
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const imageDefault = (e) => {
    e.target.src = default_mini;
  };

  const uploadFile = ({ type }) => {
    if (type == "thumbnail") {
      ImageUpload(file).then((data) => {
        setImageUrl(data);
        document.getElementById("imageFile").disabled = true;
        document.getElementById("imageUrl").disabled = true;
      });
    } else {
      ImageUpload(file2).then((data) => {
        if (data.success) {
          setImageDetails(data.data.link);
          document.getElementById("imageFile2").disabled = true;
          document.getElementById("imageDetails").disabled = true;
        } else {
          setImgur({
            error: true,
            msg: "Error with imgur api, please use URL mode.",
          });
          setTimeout(() => {
            setImgur({
              error: false,
              msg: "",
            });
          }, 2000);
        }
      });
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="cheat_modal"
        fullWidth
        maxWidth="xl"
        className="modal_cheats"
      >
        <DialogTitle id="cheat_modal" className="Title">
          {" "}
          <span>
            {type == "edit" ? "Update " + editingCheat.name : "Add New Cheat"}
          </span>{" "}
        </DialogTitle>
        <DialogContent>
          <FormControl
            variant="outlined"
            fullWidth
            className="form_modal_cheats"
          >
            <div className="form_left">
              <InputLabel id="game-select-label">Select Game</InputLabel>
              <Select
                labelId="game-select-label"
                id="game-select"
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                label="Select Game"
                fullWidth
              >
                {categories
                  ? categories.map((c, i) => (
                      <MenuItem value={c.url} key={i}>
                        {c.name}
                      </MenuItem>
                    ))
                  : null}
              </Select>
              <TextField
                autoFocus
                margin="dense"
                id="name"
                label="Name"
                type="email"
                variant="outlined"
                fullWidth
                helperText="Please use Short Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <TextField
                margin="dense"
                id="imageUrl"
                label="Cheat Thumbnail"
                value={imageUrl}
                type="text"
                variant="outlined"
                fullWidth
                helperText="You can upload an image or paste a link here!"
                onChange={(e) => setImageUrl(e.target.value)}
              />
              <div className="uploadFileDiv">
                <div className="image_cheat">
                  <img src={imageUrl} alt="" onError={imageDefault} />
                </div>
                <input
                  type="file"
                  id="imageFile"
                  onChange={(e) => setFile(e.target.files[0])}
                  className="button_upload_image"
                />
                <Button
                  onClick={() => uploadFile("thumbnail")}
                  variant="outlined"
                  color="default"
                >
                  Upload Thumbnail
                </Button>
              </div>
            </div>
            <hr></hr>
            <div className="form_right">
              <TextField
                placeholder="Cheat short description..."
                multiline
                maxRows={10}
                variant="outlined"
                className="desc_input"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
              <TextField
                autoFocus
                margin="dense"
                id="video"
                label="Video URL"
                type="text"
                variant="outlined"
                value={videoUrl}
                onChange={(e) => setVideoUrl(e.target.value)}
              />
              <FormControlLabel
                label="Show Tutorial button"
                control={
                  <Checkbox
                    value=""
                    checked={true}
                    onChange={() => console.log("change")}
                    color="primary"
                    defaultChecked
                  />
                }
              />
              <Divider className="divider_downloads" />
              <small>Downloads</small>
              <div className="downloadDiv">
                <TextField
                  autoFocus
                  margin="dense"
                  id="downloadlink1_title"
                  label="Download 1 Title"
                  type="text"
                  variant="outlined"
                  fullWidth
                  value={download1_title}
                  className="downloadTitleInput"
                  onChange={(e) => setDownload1_Title(e.target.value)}
                />
                <TextField
                  autoFocus
                  margin="dense"
                  id="downloadlink1"
                  label="Dowload Link 1"
                  type="text"
                  variant="outlined"
                  value={download1}
                  fullWidth
                  onChange={(e) => setDownload1(e.target.value)}
                />
              </div>

              <div className="downloadDiv">
                <TextField
                  autoFocus
                  margin="dense"
                  id="downloadlink2_title"
                  label="Download 2 Title (Optional)"
                  type="text"
                  variant="outlined"
                  fullWidth
                  value={download2_title}
                  className="downloadTitleInput"
                  onChange={(e) => setDownload2_Title(e.target.value)}
                />
                <TextField
                  autoFocus
                  margin="dense"
                  id="downloadlink2"
                  label="Dowload Link 2 (Optional)"
                  type="text"
                  variant="outlined"
                  fullWidth
                  value={download2}
                  onChange={(e) => setDownload2(e.target.value)}
                />
              </div>
              <Divider className="divider_downloads" />

              <TextField
                margin="dense"
                id="imageDetails"
                label="Image Details (Optional)"
                value={imageDetails}
                type="text"
                variant="outlined"
                fullWidth
                helperText="Image of mod menu / hack, if it is not filled, the thumbnail will be used as the hack image"
                onChange={(e) => setImageDetails(e.target.value)}
              />
              <div className="uploadFileDiv">
                <div className="image_cheat">
                  <img src={imageDetails} alt="" onError={imageDefault} />
                </div>
                <input
                  type="file"
                  id="imageFile2"
                  onChange={(e) => setFile2(e.target.files[0])}
                  className="button_upload_image"
                />
                <Button
                  onClick={() => uploadFile("details")}
                  variant="outlined"
                  color="default"
                >
                  Upload Image Details
                </Button>
              </div>
            </div>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleClose} color="error">
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={submitCheat}
            color="primary"
            disabled={loading ? true : false}
          >
            {type == "edit" ? "Update" : "Create"}
          </Button>
        </DialogActions>
      </Dialog>
      <AIRalert visible={error.status} text={error.msg} type="error"></AIRalert>
      <AIRalert visible={ok.status} text={ok.msg} type="success"></AIRalert>
      <AIRalert visible={imgur.error} text={imgur.msg} type="error"></AIRalert>
    </>
  );
}
